export const EU_MEMBERS = ["BE", "BG", "CZ", "DK", "DE", "EE", "IE", "EL", "ES", "FR", "HR", "IT", "CY", "LV", "LT", "LU", "HU", "MT", "NL", "AT", "PL", "PT", "RO", "SI", "SK", "FI", "SE", "GB"]
export const CANADA_MEMBERS = ["CA"]
export const US_MEMBERS = ["US", "UM"]


export const CONSENT_TARGETS = {
  EU: EU_MEMBERS,
  CANADA: CANADA_MEMBERS,
  EU_CANADA: [...CANADA_MEMBERS, ...EU_MEMBERS],
  NONE: 'NONE',
  ALL: 'ALL',
}
